import { Button } from "@heroui/react";
import { usePrintShipmentLabel } from "@/api/use-download-shipment-label";

export function PrintShipmentLabelButton({
  shipmentId,
  disabled,
  label,
  disabledTitle,
  title,
  variant = "bordered",
  color,
  className,
}: {
  shipmentId?: string;
  disabled?: boolean;
  label: string;
  disabledTitle: string;
  title?: string;
  variant?: "bordered" | "flat";
  color?: "primary";
  className?: string;
}) {
  const printLabel = usePrintShipmentLabel();

  return (
    <Button
      size="sm"
      variant={variant}
      color={color}
      className={className}
      isDisabled={disabled || !shipmentId || printLabel.isPending}
      isLoading={printLabel.isPending}
      onPress={() => shipmentId && printLabel.print(shipmentId)}
      title={disabled ? disabledTitle : title}
    >
      {printLabel.isPending ? "" : label}
    </Button>
  );
}
